import { storage as storage_ } from "./helpers"
import type { AidenResponse } from "../../types"
const VISITOR_ID_KEY = "aiden-visitor-id"

const visitorIdStore = storage_.local

export const storage = {
  set: (advisorId: string, data: Record<string, unknown>): void => {
    try {
      sessionStorage.setItem(advisorId, JSON.stringify(data))
      // eslint-disable-next-line no-empty
    } catch (e) {}
  },
  get: (advisorId: string): AidenResponse | null => {
    let data = null
    try {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      data = JSON.parse(sessionStorage.getItem(advisorId) || "")
    } catch (e) {
      try {
        sessionStorage.removeItem(advisorId)
        // eslint-disable-next-line no-empty
      } catch (e) {}
      data = null
    }
    return data as AidenResponse | null
  },
  getVisitorId: (): string | null => {
    let data = null
    try {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      data = visitorIdStore.getItem(VISITOR_ID_KEY)
    } catch (e) {
      try {
        visitorIdStore.removeItem(VISITOR_ID_KEY)
        // eslint-disable-next-line no-empty
      } catch (e) {}
      data = null
    }
    return data
  },
  setVisitorId: (userId: string) => {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    visitorIdStore.setItem(VISITOR_ID_KEY, userId)
  },
  remove: (advisorId: string): void => {
    try {
      sessionStorage.removeItem(advisorId)
      // eslint-disable-next-line no-empty
    } catch (e) {}
  },
}
